'use client';
import { categories, Category } from 'app/[lang]/startpage/page.data.ts';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const Navigation = () => {
	const homeNav: Category = {
		title: 'Startseite',
		description: '',
		path: 'startpage',
		icon: 'vetopedia_Icon_house_v01.svg',
	};
	const baseIconPath = '/icons/categories/';
	const pathname = usePathname();

	const navPoints = [homeNav, ...categories];

	return (
		<nav className='mr-3'>
			<ul>
				{navPoints.map((category, index) => (
					<li
						key={index}
						className={`text-[#414141] py-3 cursor-pointer not-last:border-b-1 border-blue-[#414141] ${
							pathname.includes(category.path) && 'font-bold '
						}`}
					>
						<Link
							href={category.path}
							className={`flex items-center gap-2 pr-4`}
						>
							<Image
								src={baseIconPath + category.icon}
								width={24}
								height={24}
								unoptimized
								alt=''
							/>
							{category.title}
						</Link>
					</li>
				))}
			</ul>
		</nav>
	);
};
export { Navigation };
